<div class="root">
    @if (
        {
            asset: asset$ | async,
            user: user$ | async,
        };
        as data
    ) {
        <div>
            @if (data.asset && data.user) {
                <div>
                    <frog-thumbnail-inspector
                        [asset]="data.asset"
                        [user]="data.user"
                    ></frog-thumbnail-inspector>
                    @if (data.asset.asset_type === AssetType.Group) {
                        <mat-divider></mat-divider>
                        <frog-group-inspector
                            [asset]="data.asset"
                            [user]="data.user"
                        ></frog-group-inspector>
                    }
                    <mat-divider></mat-divider>
                    <frog-author-inspector [asset]="data.asset"></frog-author-inspector>
                    <frog-asset-inspector
                        [asset]="data.asset"
                        [user]="data.user"
                    ></frog-asset-inspector>
                    <frog-actions-inspector
                        [asset]="data.asset"
                        [user]="data.user"
                    ></frog-actions-inspector>
                    <mat-divider></mat-divider>
                    <frog-tag-inspector [asset]="data.asset"></frog-tag-inspector>
                    <mat-divider></mat-divider>
                    <frog-annotation-inspector [asset]="data.asset"></frog-annotation-inspector>
                </div>
            } @else {
                Nothing Selected
            }
        </div>
    }
</div>
